module.exports = __webpack_public_path__ + "img/info-map.f2f4d9af.svg";